module.exports = __webpack_public_path__ + "img/app2.deb35d10.png";